import { Stack } from "@mui/material";
import type { Ref } from "react";
import { Input } from "../Input";
import type { WorkTimePart } from "./workTimeParts";

const parts: WorkTimePart[] = ["hours", "minutes", "seconds"];

export interface WorkTimeFieldsProps {
  value: Record<WorkTimePart, string | number>;
  onChange: (part: WorkTimePart, value: string) => void;
  onBlur?: (part: WorkTimePart) => void;
  errors?: Partial<Record<WorkTimePart, string>>;
  names?: Partial<Record<WorkTimePart, string>>;
  inputRefs?: Partial<Record<WorkTimePart, Ref<HTMLInputElement>>>;
  hoursLabel?: string;
}

export const WorkTimeFields = ({
  value,
  onChange,
  onBlur,
  errors,
  names,
  inputRefs,
  hoursLabel = "Hours",
}: WorkTimeFieldsProps) => (
  <Stack direction="row" spacing={1}>
    {parts.map((part) => (
      <Input
        key={part}
        label={
          part === "hours"
            ? hoursLabel
            : part === "minutes"
            ? "Minutes"
            : "Seconds"
        }
        type="number"
        name={names?.[part]}
        inputRef={inputRefs?.[part]}
        value={value[part]}
        slotProps={{
          htmlInput: { min: 0, ...(part === "hours" ? {} : { max: 59 }) },
        }}
        onChange={(event) => onChange(part, event.target.value)}
        onBlur={() => onBlur?.(part)}
        error={!!errors?.[part]}
        errorText={errors?.[part]}
        sx={{ flex: 1, minWidth: 0 }}
      />
    ))}
  </Stack>
);
